<template>
  <base-modal
    no-close-on-backdrop
    centered
    size="xl"
    :title="`Pagamento do frete do pedido ${orderId}`"
    :open.sync="open"
    :loading="loading"
  >
    <b-row v-if="loading">
      <b-col cols="12" class="text-center">
        <b-spinner label="Spinning"></b-spinner>
      </b-col>
    </b-row>
    <b-row v-else-if="!loading">
      <b-col cols="12" class="text-center mb-4">
        <span class="font-weight-bold fs-18">
          Insira os dados faltando para enviar o frete
        </span>
      </b-col>
      <b-col cols="12" class="mb-2">
        <div class="text-left font-weight-bold">Chave da Nota Fiscal</div>
        <b-input-group class="mt-1">
          <template #prepend>
            <b-input-group-text>
              <i class="fas fa-file-invoice-dollar"></i>
            </b-input-group-text>
          </template>
          <b-form-input
            v-model="invoiceKey"
            @input="requiredFields.invoiceKey = ''"
          ></b-form-input>
        </b-input-group>
        <error-message :errorMessage="requiredFields.invoiceKey" />
      </b-col>
      <b-col cols="12">
        <b-alert show variant="secondary" class="mt-4">
          <p>
            <i class="fas fa-info-circle mr-1"></i>
            Todas as transportadoras exceto Correios precisam que seja informado
            o número de nota fiscal.
          </p>
        </b-alert>
      </b-col>
    </b-row>

    <b-alert :show="error" variant="danger">
      <p>
        <i class="fas fa-exclamation-triangle mr-1"></i>
        Houve um erro ao realizar o pagamento, verifique o número da nota fiscal
        e se sua integração com o Melhor Envio está habilitada em
        <b>"Meu aplicativo -> Frete e entrega"</b> (ou
        <a href="/area-restrita/lojista/frete-app" target="_blank">
          clique aqui </a
        >).
      </p>
    </b-alert>

    <template #modal-footer>
      <b-btn variant="danger" @click="toggleOpen({})" :disabled="loading">
        <i class="fas fa-times mr-2"></i>
        Fechar
      </b-btn>
      <b-btn variant="success" @click="sendFreight()" :disabled="loading">
        <i class="fas fa-paper-plane mr-2"></i>
        Enviar frete
      </b-btn>
    </template>
  </base-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import makeToast from 'Mixins/makeToast';
import BaseModal from 'Components/Modal/BaseModal.vue';
import ErrorMessage from 'Components/ErrorMessage.vue';

import { formatNumber } from '@/utils';

export default {
  name: 'OrderDetails',
  mixins: [makeToast],
  emits: ['sent'],
  data() {
    return {
      open: false,
      loading: false,
      error: false,
      orderId: '',
      invoiceKey: '',
      shippingValue: '',
      requiredFields: {},
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  methods: {
    ...mapActions('integration', ['sendMelhorEnvioFreight']),
    formatNumber,
    toggleOpen({ orderId = 0, shippingValue = 0 }) {
      this.clean();

      this.open = !this.open;
      this.orderId = orderId;
      this.shippingValue = shippingValue;
      this.invoiceKey = '';
    },
    sendFreight() {
      this.error = false;
      this.loading = true;

      this.sendMelhorEnvioFreight({
        construpUserId: this.dadosUsuario.id,
        paymentId: this.orderId,
        invoiceKey: this.invoiceKey,
      })
        .then(() => {
          this.makeToast(
            'Sucesso',
            'Frete enviado com sucesso ao melhor envio'
          );

          this.$emit('sent');
          this.toggleOpen({});
        })
        .catch((error) => {
          this.handleErrorMessages(error.response.data.message);

          this.error = true;

          this.makeToast(
            'Erro',
            `Houve um erro ao enviar o frete do pedido: ${error.response.data.message}`,
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleErrorMessages(errorMessages) {
      if (!errorMessages) return;

      Object.keys(errorMessages).forEach((key) => {
        this.$set(this.requiredFields, key, 'Campo inválido');
      });
    },
    clean() {
      this.orderId = '';
      this.shippingValue = '';
      this.error = false;
    },
  },
  components: {
    BaseModal,
    ErrorMessage,
  },
};
</script>
